"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var LAYOUT_DIRECTION = {
  LEFT_TO_RIGHT: false,
  RIGHT_TO_LEFT: true
};
var _default = LAYOUT_DIRECTION;
exports["default"] = _default;